import React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import TrendingDownIcon from '@mui/icons-material/TrendingDown';
import { palette, radius, shadow, motion } from './designTokens';

const KpiCard = ({ icon, label, value, accent = palette.brand, delta, hint }) => {
  const positive = typeof delta === 'number' ? delta >= 0 : null;

  return (
    <Box
      sx={{
        position: 'relative',
        height: '100%',
        bgcolor: palette.surface,
        borderRadius: `${radius.md}px`,
        border: `1px solid ${palette.line}`,
        boxShadow: shadow.card,
        p: 2.25,
        transition: `transform ${motion.base}, box-shadow ${motion.base}`,
        '&:hover': { transform: 'translateY(-2px)', boxShadow: shadow.hover },
        overflow: 'hidden',
      }}
    >
      <Stack direction="row" alignItems="flex-start" justifyContent="space-between" sx={{ position: 'relative' }}>
        <Box sx={{ minWidth: 0 }}>
          <Typography sx={{ fontSize: 12, fontWeight: 600, color: palette.muted, letterSpacing: '0.02em' }}>
            {label}
          </Typography>
          <Typography
            sx={{
              fontSize: 28, fontWeight: 800, color: palette.ink, mt: 0.5,
              letterSpacing: '-0.02em', fontVariantNumeric: 'tabular-nums',
            }}
          >
            {value}
          </Typography>
          {(hint || delta != null) && (
            <Stack direction="row" alignItems="center" spacing={0.5} sx={{ mt: 0.5 }}>
              {delta != null && (
                <Stack
                  direction="row"
                  alignItems="center"
                  spacing={0.25}
                  sx={{
                    px: 0.75, py: 0.1, borderRadius: '999px',
                    bgcolor: positive ? palette.successSoft : palette.dangerSoft,
                    color: positive ? '#065F46' : '#9F1239',
                  }}
                >
                  {positive
                    ? <TrendingUpIcon sx={{ fontSize: 12 }} />
                    : <TrendingDownIcon sx={{ fontSize: 12 }} />
                  }
                  <Typography sx={{ fontSize: 11, fontWeight: 700 }}>
                    {Math.abs(delta).toFixed(1)}%
                  </Typography>
                </Stack>
              )}
              {hint && (
                <Typography sx={{ fontSize: 11, color: palette.muted }}>{hint}</Typography>
              )}
            </Stack>
          )}
        </Box>
        <Box
          sx={{
            width: 44, height: 44,
            borderRadius: `${radius.sm}px`,
            // Solid accent, white glyph — the tile IS this card's colour, so it
            // has to read as one at a glance rather than as a tinted smudge.
            bgcolor: accent,
            color: '#FFFFFF',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            flexShrink: 0,
          }}
        >
          {icon}
        </Box>
      </Stack>
    </Box>
  );
};

export default KpiCard;
